module.exports = __webpack_public_path__ + "images/product-badges/product-badge-localization-14bcf7d068bb9e2f238b552b34985183.webp";